module.exports = __webpack_public_path__ + "img/logo-bajie.6077cf47.png";